import React, { useEffect, useState } from 'react';
import Sidebar from '../../../component/b2b/sideBar/b2bSideBar';
import NavBar from '../../../component/b2b/navBar/b2bNavBar';
import Pagination from '@mui/material/Pagination';
import { useMyContext } from '../../../context/MyContext';
import { FaCcVisa, FaCcMastercard } from 'react-icons/fa';
import { useNavigate } from 'react-router-dom';
import { toast } from 'react-toastify';
import PaginationItem from '@mui/material/PaginationItem';
import { Base_Url, shippingCharges, shippingUserCharges } from '../../../config/config';

const B2bShippingCharges = () => {
  const [page, setPage] = useState(1);
  const [limit, setLimit] = useState(10);
  const [selectAll, setSelectAll] = useState(false);
  const [selectedRows, setSelectedRows] = useState([]);
  const { isDarkMode, isToggleSidebar } = useMyContext();
  const navigate = useNavigate();
  const [historyData, setHistoryData] = useState([]);
  const [totalOrders, setTotalOrders] = useState(0);
  const token = localStorage.getItem('token');
  const cus_id = localStorage.getItem('cus_id');
  const role = localStorage.getItem('role');

  useEffect(() => {
    getShipmentCharges();
  }, [page, limit]);

  const handleNavigation = () => {
    navigate("/dashboard");
  };

  const getShipmentCharges = async () => {
    const apiEndpoint = shippingCharges;
    const url = `${Base_Url}${apiEndpoint}?page=${page}&limit=${limit}`;
    try {
      const response = await fetch(url, {
        method: 'GET',
        headers: {
          token: token,
          cus_id: cus_id,
          'Content-Type': 'application/json',
        },
      });
      const data = await response.json();
      if (data.status === "SUCCESS") {
        setHistoryData(data.data);
        setTotalOrders(data.pagination.totalItems || 0);
      } else {
        toast.error(data.message);
      }
    } catch (error) {
      toast.error(`Error: ${error.message}`);
    }
  };


  const handleDownloadCSV = () => {
    if (historyData.length === 0) {
      toast.error("No data available to download.");
      return;
    }

    const headers = ['Order ID', 'User ID', 'Amount', 'Last Balance', 'Transaction Status', 'Generate Date', 'Description'];
    const csvRows = [headers.join(',')];

    historyData.forEach(row => {
      const amount = row.credit_amount === "0" || row.credit_amount === null ? row.debit_amount : row.credit_amount;
      const rowData = [
        row.order_id,
        row.user_id,
        `${amount}`,
        `${row.closing_balance || 'N/A'}`,
        row.status === "add" ? row.refund_status : row.status,
        row.txn_date,
        `"${row.txn_description || 'N/A'}"`
      ];
      csvRows.push(rowData.join(','));
    });

    const csvContent = csvRows.join('\n');
    const blob = new Blob([csvContent], { type: "text/csv;charset=utf-8;" });
    const url = URL.createObjectURL(blob);

    const link = document.createElement("a");
    link.href = url;
    link.setAttribute("download", "shipment_charges.csv");
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
    URL.revokeObjectURL(url);
  };




  const handlePaginationChange = (event, value) => {
    setPage(value);
  };

  const handleLimitChange = (event) => {
    setLimit(event.target.value);
    setPage(1);
  };

  const handleSelectAll = () => {
    if (selectAll) {
      setSelectedRows([]);
    } else {
      setSelectedRows(historyData.map((_, index) => index));
    }
    setSelectAll(!selectAll);
  };

  const handleRowSelect = (index) => {
    if (selectedRows.includes(index)) {
      setSelectedRows(selectedRows.filter(i => i !== index));
    } else {
      setSelectedRows([...selectedRows, index]);
    }
  };


  // const handleDownload = (row) => {
  //   // 1. Extract keys and values
  //   const headers = Object.keys(row);
  //   const values = Object.values(row);

  //   // 2. Create a CSV string
  //   const csvContent = `${headers.join(",")}\n${values.map(v => `"${String(v).replace(/"/g, '""')}"`).join(",")}`;

  //   // 3. Create Blob and trigger download
  //   const blob = new Blob([csvContent], { type: "text/csv;charset=utf-8;" });
  //   const url = URL.createObjectURL(blob);

  //   const link = document.createElement("a");
  //   link.href = url;
  //   link.setAttribute("download", `transaction_${row.order_id || row.id}.csv`);
  //   document.body.appendChild(link);
  //   link.click();
  //   document.body.removeChild(link);
  //   URL.revokeObjectURL(url);
  // };

  const renderTableHeaders = () => {
    const headers = ['Order ID', 'Amount', 'Last Balance', 'Transaction Status', 'Generate Date', 'Description'];

    if (role === 'admin') {
      headers.unshift('User ID');  // Add at the beginning for admin
      // headers.push('Action');
    }

    return headers;
  };

  const getStatusColor = (status, refundStatus) => {
    if (status === "add") {
      switch (refundStatus?.toLowerCase()) {
        case 'completed':
          return 'bg-black text-white border-black dark:bg-white dark:text-black dark:border-white';
        case 'pending':
          return 'bg-white text-black border-black dark:bg-black dark:text-white dark:border-white';
        case 'failed':
          return 'bg-gray-800 text-white border-gray-800 dark:bg-gray-200 dark:text-black dark:border-gray-200';
        default:
          return 'bg-gray-100 text-black border-gray-400 dark:bg-gray-700 dark:text-white dark:border-gray-500';
      }
    } else {
      return 'bg-gray-100 text-gray-800 border-gray-300 dark:bg-gray-800 dark:text-gray-200 dark:border-gray-600';
    }
  };

  const renderTableRow = (row, index) => (
    <tr
      key={row.id}
      className={`dark:bg-black dark:text-white hover:bg-gray-100 dark:hover:bg-gray-900 transition-colors ${index % 2 === 0 ? 'bg-white' : 'bg-gray-50'
        }`}
    >
      {role === 'admin' && (
        <td className="p-2 text-[12px] text-black dark:text-white font-normal border-b border-gray-200 dark:border-gray-700">
          {row.user_id}
        </td>
      )}
      <td className="relative group p-2 text-[12px] text-black dark:text-white cursor-pointer font-normal underline decoration-gray-300 hover:decoration-black dark:hover:decoration-white transition-colors border-b border-gray-200 dark:border-gray-700">
        {row.order_id}
        {/* <div className="absolute left-0 top-full mt-1 hidden group-hover:block bg-gray-900 dark:bg-gray-800 text-white text-[10px] rounded-md px-2 py-1 shadow-lg z-10 whitespace-nowrap">
          💰 View charge details here!
          <div className="absolute -top-1 left-3 w-1.5 h-1.5 bg-gray-900 dark:bg-gray-800 rotate-45"></div>
        </div> */}
      </td>
      <td className="p-2 text-[12px] text-black font-normal dark:text-white border-b border-gray-200 dark:border-gray-700">
        ₹{row.credit_amount === "0" || row.credit_amount === null ? row.debit_amount : row.credit_amount}
      </td>
      <td className="p-2 text-[12px] text-black dark:text-white border-b border-gray-200 dark:border-gray-700">
        ₹{row.closing_balance || 'N/A'}
      </td>
      <td className="p-2 border-b border-gray-200 dark:border-gray-700">
        {row.status === "add" ? (
          <span className={`inline-flex items-center px-2 py-1 rounded-full text-xs font-normal border ${getStatusColor(row.status, row.refund_status)}`}>
            {row.refund_status}
          </span>
        ) : (
          <span className={`inline-flex items-center px-2 py-1 rounded-full text-xs font-normal border ${getStatusColor(row.status)}`}>
            {row.status}
          </span>
        )}
      </td>
      <td className="p-2 text-[12px] text-black dark:text-white border-b border-gray-200 dark:border-gray-700">
        {row.txn_date || 'N/A'}
      </td>
      <td className="p-2 text-[12px] text-black dark:text-white max-w-xs border-b border-gray-200 dark:border-gray-700">
        <div
          className="truncate hover:text-clip hover:whitespace-normal cursor-help"
          title={row.txn_description || "No description available"}
        >
          {row.txn_description || "N/A"}
        </div>
      </td>

      {/* ➕ Download Action Column */}
      {/* <td className="p-2 text-xs">
        <button
          onClick={() => handleDownload(row)}
          className="px-3 py-1 bg-blue-600 hover:bg-blue-700 text-white rounded-md text-xs transition-colors"
        >
          Download
        </button>
      </td> */}
    </tr>
  );


  return (
    <div className={`h-screen flex flex-col overflow-hidden ${isDarkMode ? 'dark:bg-black' : 'bg-white'}`}>
      <NavBar />
      <div className="flex flex-1 overflow-hidden">
        {isToggleSidebar && (
          <div className={`fixed z-20 h-full w-64 md:relative bg-white dark:bg-black dark:text-white mt-4 duration-300 border-r border-gray-200 dark:border-gray-800 ${window.innerWidth < 768 ? 'top-28' : ''}`}>
            <Sidebar />
          </div>
        )}

        {/* Page wrapper: fixed, no page-level scroll */}
        <div className="flex flex-col w-full h-full overflow-hidden bg-gray-200 dark:bg-black dark:text-white border border-gray-200 dark:border-gray-800 ">

          {/* Header (fixed, does not scroll) */}
          <div className="flex flex-col sm:flex-row items-center gap-4 p-4 shrink-0 border-b border-gray-200 dark:border-gray-800">
            <button
              // onClick={handleNavigation}
              className="flex-1 w-full sm:w-auto text-lg sm:text-xl font-bold bg-blue-600  dark:bg-white dark:text-black dark:hover:bg-gray-200 text-white font-sans px-4 py-3 sm:py-2 rounded h-auto sm:h-[35px] flex items-center justify-center transition-colors duration-200  dark:border-white"
            >
              <FaCcVisa className="mr-2 flex-shrink-0" size={20} />
              <FaCcMastercard className="mr-2 flex-shrink-0" size={20} />
              <span className="whitespace-nowrap">Shipments Charges</span>
            </button>

            <button
              onClick={handleDownloadCSV}
              className="w-full sm:w-auto text-sm font-medium h-auto sm:h-[35px] bg-white hover:bg-gray-100 text-black border border-black dark:bg-black dark:text-white dark:border-white dark:hover:bg-gray-900 px-4 py-3 sm:py-2 rounded flex items-center justify-center transition-colors duration-200"
            >
              <span className="mr-2">📥</span>
              <span className="whitespace-nowrap">Download CSV</span>
            </button>
          </div>

          {/* Table area: ONLY this part scrolls */}
          <div className="flex-1 overflow-auto custom-scrollbar p-4">
            <div className="overflow-x-auto rounded-md border border-gray-200 dark:border-gray-800">
              <table className="min-w-full table-auto dark:bg-black dark:text-white">
                <thead className='bg-blue-600 text-white text-[12px] dark:bg-white dark:text-black sticky top-0 z-10'>
                  <tr>
                    {/* <th className="p-2 text-left font-medium">
                      <input
                        type="checkbox"
                        checked={selectAll}
                        onChange={handleSelectAll}
                        className="w-4 h-4 ml-1 text-blue-600 bg-white border-gray-300 rounded focus:ring-blue-500"
                      />
                    </th> */}
                    {renderTableHeaders().map((header, index) => (
                      <th key={index} className="p-2 text-left text-[12px] font-normal">{header}</th>
                    ))}
                  </tr>
                </thead>
                <tbody className="divide-y divide-gray-200 dark:divide-gray-800 dark:bg-black dark:text-white">
                  {historyData.length > 0 ? historyData.map((row, index) => renderTableRow(row, index)) : (
                    <tr>
                      <td colSpan={role === 'admin' ? "8" : "7"} className="text-center p-4 text-gray-500 dark:text-gray-400">
                        No shipping charges history available.
                      </td>
                    </tr>
                  )}
                </tbody>
              </table>
            </div>
          </div>

          {/* Footer / pagination (fixed, does not scroll) */}
          <div className="shrink-0 p-4 border-t border-gray-200 dark:border-gray-800 flex flex-col sm:flex-row justify-between items-center space-y-2 sm:space-y-0">
            <span className="text-xs text-black font-bold dark:text-gray-200">{`Total Orders: ${totalOrders}`}</span>
            <select
              id="limit"
              value={limit}
              onChange={handleLimitChange}
              className={`border border-black dark:border-white rounded p-1 text-xs bg-white dark:bg-black dark:text-white ${totalOrders < 10 ? 'cursor-not-allowed opacity-40' : ''}`}
              disabled={totalOrders < 10}
            >
              {totalOrders === 0 ? (
                <option value={0}>0</option>
              ) : (
                <>
                  <option value={10}>10</option>
                  <option value={15}>15</option>
                  <option value={20}>20</option>
                  <option value={30}>30</option>
                  <option value={totalOrders}>All</option>
                </>
              )}
            </select>

            <Pagination
              count={Math.ceil(totalOrders / limit)}
              page={page}
              onChange={handlePaginationChange}
              variant="outlined"
              shape="rounded"
              className="pagination"
              size="small"
              renderItem={(item) => (
                <PaginationItem
                  {...item}
                  className={`mx-1 rounded-md ${item.selected ? 'bg-black text-white dark:bg-white dark:text-black' : 'text-black dark:text-gray-300'} hover:bg-black hover:text-white dark:hover:bg-white dark:hover:text-black`}
                />
              )}
            />
          </div>
        </div>
      </div>
    </div>
  );
};

export default B2bShippingCharges;